import { Component, HostListener } from '@angular/core';
import { SeguridadService } from './core/service/seguridad/seguridad.service';
import { Subject } from 'rxjs';
import { MyMonitoringService } from './core/service/logging.service';
import { EnvconfigService } from './core/service/envconfig.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Chart, registerables } from 'chart.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent {
  title = 'SIMP-FRONTEND';
  name = 'Ngx Mask';
  timeout : number  = 0;
  userActivity: ReturnType<typeof setTimeout> | undefined;
  userInactive: Subject<any> = new Subject();
  constructor( 
    private seguridadService: SeguridadService,
    private myMonitoringService: MyMonitoringService,
    private environment: EnvconfigService,
     private spinner: NgxSpinnerService
    ) {
      this.timeout = Number(environment.get("TIEMPO_SESSION"))
      this.setTimeout();
    this.userInactive.subscribe(() =>{
      this.seguridadService.cerrarSesionInactividad();

    }
    );
  }

  ngOnInit() {
    this.environment.initializeAppTitle();
     this.spinner.show();
     setTimeout(() => {
       this.spinner.hide();
     }, 3000);    
  }
  setTimeout() {
    this.userActivity = setTimeout(
      () => this.userInactive.next(undefined),
      1000 * 60 * Number(this.timeout)
    );
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
}